﻿export const projectSettings = {
	phoneNumber: (window.projectSettings && window.projectSettings.phoneNumber) || "",
	emailAddress: (window.projectSettings && window.projectSettings.emailAddress) || "",
	classActionName: (window.projectSettings && window.projectSettings.classActionName) || "",
	lfaDocumentUrl: (window.projectSettings && window.projectSettings.lfaDocumentUrl) || "",
	costAgreementDocumentUrl: (window.projectSettings && window.projectSettings.costAgreementDocumentUrl) || "",
	serviceUrl: (window.projectSettings && window.projectSettings.serviceUrl) || "",
	gSiteKey2: (window.projectSettings && window.projectSettings.gSiteKey2) || "",
	gSiteKey3: (window.projectSettings && window.projectSettings.gSiteKey3) || ""
};

const registrationPageIndex = {
	LandingPage: 0,
	PersonalDetails: 1,
	Details: 2,
	Confirmation: 3,
	ThankYou: 4,
	Review: 5,
	Error: 6
};

const fileUploadPageIndex = {
	FileUploadLandingPage: 0,
	FileUploadFiles: 1,
	FileUploadThankYou: 2,
	Error: 3
};

const confirmAgreementsPageIndex = {
	ConfirmAgreements_LandingPage: 0,
	ConfirmAgreements_CostAndFundingAgreements: 1,
	ConfirmAgreements_ThankYou: 2,
	Error: 3
};

const acknowledgeUpdatedAgreementsPageIndex = {
	AckUpdatedAgreements_LandingPage: 0,
	AckUpdatedAgreements_Letter: 1,
	AckUpdatedAgreements_ThankYou: 2,
	Error: 3
};

const acknowledgeAmendmentsPageIndexAU = {
	AckAU_LandingPage: 0,
	AckAU_Letter: 1,
	AckAU_ThankYou: 2,
	Error: 3
};

const acknowledgeAmendmentsPageIndexOS = {
	AckOS_LandingPage: 0,
	AckOS_Letter: 1,
	AckOS_Funding: 2,
	AckOS_Disclosure: 3,
	AckOS_ThankYou: 4,
	Error: 5
};

const agreementsAcceptancePageIndex = {
	AgreementsAcceptance_LandingPage: 0,
	AgreementsAcceptance_Cost: 1,
	AgreementsAcceptance_Funding: 2,
	AgreementsAcceptance_ThankYou: 3,
	Error: 4
};

const questionnairePageIndex = {
	Questionnaire_Questions: 0,
	Questionnaire_Confirmation: 1,
	Questionnaire_ThankYou: 2,
	Questionnaire_Review: 3,
	Error: 4
};

const questionnaire2PageIndex = {
	Questionnaire2_Questions: 0,
	Questionnaire2_Confirmation: 1,
	Questionnaire2_ThankYou: 2,
	Questionnaire2_Review: 3,
	Error: 4
};

const registrationPageList = [
	{
		pageIndex: 0,
		pageTitle: `${projectSettings.classActionName}`,
		title: "Landing Page",
		showInTracker: false,
		lastVisitedPage: "Landing Page",
		nextPage: "Registration/PersonalDetails"
	},
	{
		pageIndex: 1,
		title: "Personal Details",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} - Personal Details`,
		nextPage: "Registration/Details",
		previousPage: "Registration",
		persistUrl: "api/project",
		lastVisitedPage: "Personal Details"
	},
	{
		pageIndex: 2,
		title: "Details",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} - Details`,
		nextPage: "Registration/Confirmation",
		previousPage: "Registration/PersonalDetails",
		persistUrl: "api/project",
		lastVisitedPage: "Details"
	},
	// {
	//     pageIndex: 3,
	//     title: "Funding Agreement and Costs Agreement",
	//     showInTracker: true,
	//     pageTitle: `${projectSettings.classActionName} - Funding Agreement and Costs Agreement`,
	//     nextPage: "Registration/Confirmation",
	//     previousPage: "Registration/Details",
	//     persistUrl: "api/project",
	//     lastVisitedPage: "Funding Agreement and Costs Agreement"
	// },
	{
		pageIndex: 3,
		title: "Confirmation",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} - Confirmation`,
		previousPage: "Registration/Details",
		nextPage: "Registration/ThankYou",
		nextPageLabel: "Submit",
		persistUrl: "api/registration",
		lastVisitedPage: "Confirmation"
	},
	{
		pageIndex: 4,
		title: "Thank you",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} - Thank you`
	},
	{
		pageIndex: 5,
		title: "Review",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} - Review`
	},
	{
		pageIndex: 6,
		title: "Error",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} - Error`
	}
];

const fileUploadPageList = [
	{
		pageIndex: 0,
		pageTitle: `${projectSettings.classActionName}`,
		title: "Landing Page",
		showInTracker: false,
		nextPage: "FileUpload/Files"
	},
	{
		pageIndex: 1,
		title: "Files",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} - Files`,
		nextPage: "FileUpload/Thankyou",
		previousPage: "FileUpload",
		nextPageLabel: "Submit",
		persistUrl: "api/file-upload-submit"
	},
	{
		pageIndex: 2,
		title: "Thank you",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} - Thank you`
	},
	{
		pageIndex: 3,
		title: "Error",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} - Error`
	}
];

const confirmAgreementsPageList = [
	{
		pageIndex: 0,
		pageTitle: `${projectSettings.classActionName} Class Action`,
		title: "Landing Page",
		showInTracker: false,
		nextPage: "ConfirmAgreements/Confirm"
	},
	{
		pageIndex: 1,
		title: "Confirm Agreements",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Confirm Agreements`,
		nextPage: "ConfirmAgreements/Thankyou",
		previousPage: "ConfirmAgreements",
		nextPageLabel: "Submit",
		persistUrl: "api/agreements"
	},
	{
		pageIndex: 2,
		title: "Thank you",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Thank you`
	},
	{
		pageIndex: 3,
		title: "Error",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} Class Action - Error`
	}
];

const acknowledgeAmendmentsPageListAU = [
	{
		pageIndex: 0,
		pageTitle: `${projectSettings.classActionName} Class Action`,
		title: "Landing Page",
		showInTracker: false,
		nextPage: "AcknowledgeAmendments/Letter"
	},
	{
		pageIndex: 1,
		title: "Letter re Cost Agreement",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Letter re Cost Agreement`,
		nextPage: "AcknowledgeAmendments/Thankyou",
		previousPage: "AcknowledgeAmendments",
		nextPageLabel: "Submit",
		persistUrl: "api/acknowledge-amendments"
	},
	{
		pageIndex: 2,
		title: "Dummy",
		showInTracker: false
	},
	{
		pageIndex: 3,
		title: "Dummy",
		showInTracker: false
	},
	{
		pageIndex: 4,
		title: "Thank you",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Thank you`
	},
	{
		pageIndex: 5,
		title: "Error",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} Class Action - Error`
	}
];

const acknowledgeAmendmentsPageListOS = [
	{
		pageIndex: 0,
		pageTitle: `${projectSettings.classActionName} Class Action`,
		title: "Landing Page",
		showInTracker: false,
		nextPage: "AcknowledgeAmendments/Letter"
	},
	{
		pageIndex: 1,
		title: "Letter re Cost Agreement",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Letter re Cost Agreement`,
		nextPage: "AcknowledgeAmendments/Funding",
		nextPageLabel: "Next",
		previousPage: "AcknowledgeAmendments"
	},
	{
		pageIndex: 2,
		title: "Funding Agreement",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Funding Agreement`,
		nextPage: "AcknowledgeAmendments/Disclosure",
		nextPageLabel: "Next",
		previousPage: "AcknowledgeAmendments/Letter"
	},
	{
		pageIndex: 3,
		title: "Conflicts Disclosure Statement",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Conflicts Disclosure Statement`,
		nextPage: "AcknowledgeAmendments/Thankyou",
		previousPage: "AcknowledgeAmendments/Funding",
		nextPageLabel: "Submit",
		persistUrl: "api/acknowledge-amendments"
	},
	{
		pageIndex: 4,
		title: "Thank you",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Thank you`
	},
	{
		pageIndex: 5,
		title: "Error",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} Class Action - Error`
	}
];

const acknowledgeUpdatedAgreementsPageList = [
	{
		pageIndex: 0,
		pageTitle: `${projectSettings.classActionName} Class Action`,
		title: "Landing Page",
		showInTracker: false,
		nextPage: "AcknowledgeUpdatedAgreements/Letter"
	},
	{
		pageIndex: 1,
		title: "Letter re Cost Agreement",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Letter re Cost Agreement`,
		nextPage: "AcknowledgeUpdatedAgreements/Thankyou",
		previousPage: "AcknowledgeUpdatedAgreements",
		nextPageLabel: "Submit",
		persistUrl: "api/acknowledge-updated-agreements"
	},
	{
		pageIndex: 2,
		title: "Thank you",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Thank you`
	},
	{
		pageIndex: 3,
		title: "Error",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} Class Action - Error`
	}
];

const agreementsAcceptancePageList = [
	{
		pageIndex: 0,
		pageTitle: `${projectSettings.classActionName} Class Action`,
		title: "Landing Page",
		showInTracker: false,
		nextPage: "AgreementsAcceptance/Cost"
	},
	{
		pageIndex: 1,
		title: "Costs Agreement",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Costs Agreement`,
		nextPage: "AgreementsAcceptance/Funding",
		previousPage: "AgreementsAcceptance",
		nextPageLabel: "Next"
	},
	{
		pageIndex: 2,
		title: "Funding Agreement",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Funding Agreement`,
		nextPage: "AgreementsAcceptance/Thankyou",
		previousPage: "AgreementsAcceptance/Cost",
		nextPageLabel: "Submit",
		persistUrl: "api/agreements-acceptance"
	},
	{
		pageIndex: 3,
		title: "Thank you",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Thank you`
	},
	{
		pageIndex: 4,
		title: "Error",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} Class Action - Error`
	}
];

const questionnairePageList = [
	{
		pageIndex: 0,
		pageTitle: `${projectSettings.classActionName} Class Action`,
		title: "Questionnaire",
		showInTracker: false,
		nnnnnextPageLabel: "Submit",
		pppppersistUrl: "api/questionnaire",
		nextPage: "Questionnaire/Confirmation",
		lastVisitedPage: "Questionnaire"
	},
	{
		pageIndex: 1,
		title: "Confirmation",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} - Confirmation`,
		previousPage: "Questionnaire/Questions",
		nextPage: "Questionnaire/ThankYou",
		nextPageLabel: "Submit",
		persistUrl: "api/questionnaire",
		lastVisitedPage: "Confirmation"
	},
	{
		pageIndex: 2,
		title: "Thank you",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Thank you`
	},
	{
		pageIndex: 3,
		title: "Questionnaire/Review",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} Class Action - Review`
	},
	{
		pageIndex: 4,
		title: "Error",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} Class Action - Error`
	}
];

const questionnaire2PageList = [
	{
		pageIndex: 0,
		pageTitle: `${projectSettings.classActionName} Class Action`,
		title: "Questionnaire 2",
		showInTracker: false,
		nextPage: "Questionnaire2/Confirmation",
		lastVisitedPage: "Questionnaire 2"
	},
	{
		pageIndex: 1,
		title: "Confirmation",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} - Confirmation`,
		previousPage: "Questionnaire2/Questions",
		nextPage: "Questionnaire2/ThankYou",
		nextPageLabel: "Submit",
		persistUrl: "api/questionnaire",
		lastVisitedPage: "Confirmation"
	},
	{
		pageIndex: 2,
		title: "Thank you",
		showInTracker: true,
		pageTitle: `${projectSettings.classActionName} Class Action - Thank you`
	},
	{
		pageIndex: 3,
		title: "Questionnaire2/Review",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} Class Action - Review`
	},
	{
		pageIndex: 4,
		title: "Error",
		showInTracker: false,
		pageTitle: `${projectSettings.classActionName} Class Action - Error`
	}
];

export const applicationPages = {
	registrationPageIndex: registrationPageIndex,
	registrationPageList: registrationPageList,
	fileUploadPageIndex: fileUploadPageIndex,
	fileUploadPageList: fileUploadPageList,
	confirmAgreementsPageIndex: confirmAgreementsPageIndex,
	confirmAgreementsPageList: confirmAgreementsPageList,
	acknowledgeAmendmentsPageIndexAU: acknowledgeAmendmentsPageIndexAU,
	acknowledgeAmendmentsPageListAU: acknowledgeAmendmentsPageListAU,
	acknowledgeAmendmentsPageIndexOS: acknowledgeAmendmentsPageIndexOS,
	acknowledgeAmendmentsPageListOS: acknowledgeAmendmentsPageListOS,
	acknowledgeUpdatedAgreementsPageIndex: acknowledgeUpdatedAgreementsPageIndex,
	acknowledgeUpdatedAgreementsPageList: acknowledgeUpdatedAgreementsPageList,
	agreementsAcceptancePageIndex: agreementsAcceptancePageIndex,
	agreementsAcceptancePageList: agreementsAcceptancePageList,
	questionnaire2PageList: questionnaire2PageList,
	questionnaire2PageIndex: questionnaire2PageIndex,
	questionnairePageList: questionnairePageList,
	questionnairePageIndex: questionnairePageIndex
};

export const referralTypes = [
	{ name: "Advertising" },
	{ name: "Client" },
	{ name: "Online" },
	{ name: "Family/Friend" },
	{ name: "Professional Referral" },
	{ name: "Staff Referral" },
	{ name: "Media" },
	{ name: "Word of Mouth" },
	{ name: "Other" }
];

export const salutationTypes = [
	{ name: "Dr" },
	{ name: "Mr" },
	{ name: "Miss" },
	{ name: "Ms" },
	{ name: "Mrs" },
	{ name: "Other" }
];

export const relationshipTypes = [
	{ name: "Parent" },
	{ name: "Family Member" },
	{ name: "Spouse " },
	{ name: "Other" }
];

export const acceptedFileUploadList = "application/pdf,image/*,application/docx,text/plain,application/msword";

export const yesNoOptions = [
	{ label: "Yes", value: "Yes" },
	{ label: "No", value: "No" }
];
